export const ApiConfig = {
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',
    apiRetry: Number(import.meta.env.VITE_API_RETRY) || 3, // default retries
    
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 10000, // in ms
    useMock: import.meta.env.VITE_USE_MOCK === 'true', // for testing frontend without backend
    withCredentials: import.meta.env.VITE_API_CREDENTIALS === 'true', // include cookies
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-App-Version': '1.0.0',
    },
}   